'use client';
import { Box } from '@mui/material';
import { FunctionComponent, ReactNode } from 'react';
import { useResponsive } from '../../../contexts/ResponsiveContext';

interface ProductFilterContainerProps {
    children: ReactNode;
    isFilterControllerOpen: boolean;
}

const ProductFilterContainer: FunctionComponent<ProductFilterContainerProps> = ({
    children,
    isFilterControllerOpen,
}) => {
    const {
        isMaxScreen,
        isScreenXxl,
        isScreenXl,
        isScreenLg,
        isScreenMd,
        isScreenSm,
        isScreenXs,
        responsiveWidth,
    } = useResponsive();

    const isMobileSize = isScreenMd || isScreenSm || isScreenXs;
    const getProductFilterContainerPadding = () => {
        if (isMobileSize) {
            return '0px';
        }
        return isFilterControllerOpen ? '5px 20px 0px 20px' : '10px 20px 0px 20px';
    };

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                padding: getProductFilterContainerPadding(),
                width: '100%',
                boxSizing: 'border-box', // 包含padding在內的總寬度
                flexDirection: 'column', // 確保內容是垂直排列
                overflowY: 'hidden',
                backgroundColor: isMobileSize ? 'white' : '#F2F2F2',
            }}
            data-testid={'product-filter-container'}
        >
            {children}
        </Box>
    );
};

export default ProductFilterContainer;
